import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { referralAPI } from '../services/api';
import { toast } from 'react-hot-toast';
import VaultoLogo from './VaultoLogo';

const ReferralRedirect = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [validating, setValidating] = useState(true);

  useEffect(() => {
    const handleReferral = async () => {
      if (!code) {
        navigate('/register');
        return;
      }

      try {
        // Track the referral visit
        await referralAPI.trackVisit(code);
        
        // Validate the referral code
        const response = await referralAPI.validateCode(code);
        
        if (response.data?.valid) {
          // Redirect to registration with referral code
          navigate(`/register?ref=${code}`);
        } else {
          toast.error('Invalid referral code');
          navigate('/register');
        }
      } catch (error) {
        console.error('Error handling referral:', error);
        // Still redirect to registration even if tracking fails
        navigate(`/register?ref=${code}`);
      }
    };

    handleReferral();
  }, [code, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-900 via-purple-900 to-pink-800 flex items-center justify-center">
      <div className="text-center">
        <VaultoLogo className="h-16 w-auto mx-auto mb-4" showText={true} />
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto"></div>
        <p className="mt-4 text-white">Redirecting...</p>
      </div>
    </div>
  );
};

export default ReferralRedirect;


